<template>
  <div class="staff-engineer">
    <el-row :gutter="24">
      <el-col :span="12">
        <div class="progress-box left">
          <div class="title flex-between">
            <template v-if="$lange == 'en'">
              <div class="total">
                Number of Engineer {{ engineerData.engineerNum }}
              </div>
            </template>
            <template v-else>
              <div class="total">工程师 {{ engineerData.engineerNum }} 人</div>
            </template>
          </div>
          <div class="lists">
            <div
              class="list flex-between"
              :class="colorArr[index]"
              v-for="(item, index) in engineerData.engineerList"
            >
              <p>{{ item.name }} {{ item.value }} 人</p>
              <el-progress
                :percentage="
                  engineerData.engineerNum == 0
                    ? 0
                    : (item.value / engineerData.engineerNum) * 100
                "
                :show-text="false"
              ></el-progress>
            </div>
          </div>
        </div>
      </el-col>
      <el-col :span="12">
        <div class="progress-box right">
          <div class="title flex-between">
            <template v-if="$lange == 'en'">
              <div class="total">
                Days of business trip {{ engineerData.expatriateNum }}
              </div>
            </template>
            <template v-else>
              <div class="total">
                出差天数总计 {{ engineerData.expatriateNum }} 天
              </div>
            </template>

            <el-date-picker
              v-model="monthData"
              align="right"
              type="month"
              size="mini"
              :placeholder="$lange == 'en' ? 'Please Choose Date' : '选择年月'"
              @change="changeDate"
            ></el-date-picker>
          </div>
          <div class="lists">
            <div
              class="list flex-between"
              :class="colorArr[index]"
              v-for="(item, index) in engineerData.expatriateList"
            >
              <p>{{ item.name }} {{ item.value }} 天</p>
              <el-progress
                :percentage="
                  engineerData.dayTotal == 0
                    ? 0
                    : (item.value / engineerData.dayTotal) * 100
                "
                :show-text="false"
              ></el-progress>
            </div>
          </div>
        </div>
      </el-col>
    </el-row>
    <div class="table-box">
      <div class="top flex-between">
        <div class="left">
          <div class="month-group">
            <el-radio-group
              v-model="monthRadio"
              size="mini"
              @change="daysChange"
            >
              <el-radio-button label="60">60天</el-radio-button>
              <el-radio-button label="120">120天</el-radio-button>
            </el-radio-group>
          </div>
          <p>{{ $lange == "en" ? "Today" : "当前日期" }}: {{ nowDate }}</p>
          <p>
            {{ $lange == "en" ? "Number of Engineer" : "工程师人数" }}:
            {{ engineerData.engineerNum }}
          </p>
          <p>
            {{ $lange == "en" ? "Travelling" : "外派" }}:
            {{ engineerData.expatriateCount }}
          </p>
          <p>
            {{ $lange == "en" ? "on leave" : "请假" }}:
            {{ engineerData.leaveCount }}
          </p>
        </div>
        <div class="btn-group">
          <el-button type="primary" size="mini" @click="showReport = true">{{
            $lange == "en" ? "View / export daily report" : "查看/导出日报"
          }}</el-button>
          <el-button type="primary" size="mini" @click="showVacation = true">{{
            $lange == "en" ? "Vacation entry" : "休假录入"
          }}</el-button>
        </div>
      </div>
      <div class="gantt-box">
        <div class="input-group">
          <div class="group-left">
            <div class="input_item">
              <el-input
                type="primary"
                size="mini"
                v-model="tableParams.userName"
                :placeholder="
                  $lange == 'en' ? 'Engineer name' : '请输入工程师名称'
                "
              ></el-input>
            </div>
            <div class="input_item">
              <el-select
                v-model="tableParams.categoryName"
                :placeholder="
                  $lange == 'en' ? 'Engineer Category' : '请选择工程师类别'
                "
                size="mini"
                clearable
                clearable
              >
                <el-option
                  v-for="item in categoryName"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
              <!-- <el-input type="primary" size="mini" v-model="tableParams.categoryName" :placeholder="$lange=='en' ? 'Engineer Category' : '请输入工程师类别'"></el-input> -->
            </div>
            <div class="input_item">
              <!-- <el-input
                type="primary"
                size="mini"
                v-model="tableParams.skill"
                :placeholder="$lange=='en' ? 'Engineer Skill' : '请输入工程师技能'"
              ></el-input>-->
              <el-select
                v-model="tableParams.skill"
                :placeholder="
                  $lange == 'en' ? 'Engineer Skill' : '请选择工程师技能'
                "
                size="mini"
                clearable
              >
                <el-option
                  v-for="item in skill"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </div>
            <div class="input_item">
              <el-input
                type="primary"
                size="mini"
                v-model="tableParams.station"
                :placeholder="
                  $lange == 'en' ? 'Engineer Position' : '请输入工程师位置'
                "
              ></el-input>
            </div>
            <el-button type="primary" size="mini" @click="initGanntDate">{{
              $lange == "en" ? "Search" : "搜索"
            }}</el-button>
          </div>
          <div class="group-right">
            <div class="color_box color_1">
              {{ $lange == "en" ? "Installation" : "安裝" }}
            </div>
            <div class="color_box color_2">
              {{ $lange == "en" ? "Service" : "售后" }}
            </div>
            <div class="color_box color_3">
              {{ $lange == "en" ? "On Leave" : "休假" }}
            </div>
          </div>
        </div>
        <el-row>
          <el-col :span="6">
            <div class="table-box not-padding" style="padding: 0">
              <cc-table
                :config="tableConfig"
                :params="tableParams"
                :data-arr="ganttTableData"
                :load-data="false"
              ></cc-table>
            </div>
          </el-col>
          <el-col :span="18" style="padding: 20px 20px 20px 0">
            <template v-if="loadTable">
              <Gantt
                :utasks="ganttData"
                :isStartTime="showDateRange.startTime"
                :isEndTime="showDateRange.endTime"
                :childHeight="36"
                class-name="staff_engineer_box"
              ></Gantt>
            </template>
          </el-col>
        </el-row>
      </div>
    </div>
    <el-dialog
      :title="$lange == 'en' ? 'View / export daily report' : '查看/导出日报'"
      :visible.sync="showReport"
      width="85%"
      append-to-body
    >
      <el-date-picker
        v-model="exportDate"
        value-format="yyyy-MM-dd"
        type="daterange"
        size="mini"
        :range-separator="$lange == 'en' ? 'to' : '到'"
        :start-placeholder="$lange == 'en' ? 'Start Time' : '开始日期'"
        :end-placeholder="$lange == 'en' ? 'End Time' : '结束日期'"
        @change="exportDateChange"
      ></el-date-picker>
      <cc-selector
        :config="productSelectorConfig"
        style="width: 200px; margin-left: 15px; margin-right: 15px"
        :placeholder="$lange == 'en' ? 'Select ID' : '请选择Job ID'"
        v-model="baseTableParams.jobId"
      />
      <el-button type="primary" size="mini" @click="exportDailyReport">{{
        $lange == "en" ? "Export" : "导出日报"
      }}</el-button>
      <cc-table
        style="margin-top: 15px"
        :params="baseTableParams"
        :config="baseTableConfig"
      >
        <!--                    <cc-selector :config="engineerSelectorConfig"-->
        <!--                                 style="width:200px;"-->
        <!--                                 placeholder="请选择工程师"-->
        <!--                                 v-model="tableParams.userIds" />-->
      </cc-table>
    </el-dialog>
    <el-dialog
      :title="$lange == 'en' ? 'Vacation entry' : '休假录入'"
      :visible.sync="showVacation"
      width="40%"
      append-to-body
    >
      <div class="enter-vacation">
        <div>
          <span class="item-title require-class">选择休假日期:</span>
          <el-date-picker
            style="width: 150px"
            v-model="engineerParams.startDate"
            value-format="yyyy-MM-dd"
            type="date"
            size="mini"
            :placeholder="$lange == 'en' ? 'Choose Date' : '选择日期'"
          ></el-date-picker>
          {{ $lange == "en" ? "to" : "到" }}
          <el-date-picker
            style="width: 150px"
            v-model="engineerParams.endDate"
            value-format="yyyy-MM-dd"
            type="date"
            size="mini"
            :placeholder="$lange == 'en' ? 'Choose Date' : '选择日期'"
          ></el-date-picker>
        </div>
        <div style="margin: 15px 0">
          <span class="item-title require-class"
            >{{ $lange == "en" ? "Engineer" : "工程师" }}:</span
          >
          <cc-selector
            :config="engineerSelectorConfig"
            style="width: 200px"
            :placeholder="$lange == 'en' ? 'Choose Engineer' : '请选择工程师'"
            v-model="engineerParams.userIds"
          />
        </div>

        <span class="item-title" style="width: 165px; margin-top: 20px">
          <el-button size="mini" type="primary" @click="vacationEngineer">{{
            $lange == "en" ? "Save" : "保存"
          }}</el-button>
        </span>
        <div class="table-box" style="border-top: 1px solid #eee">
          <div class="top" style="max-width: 200px">
            <p style="font-size: 18px">
              {{ $lange == "en" ? "Vacation list" : "休假列表" }}
            </p>
            <el-input
              style="margin-left: 0; margin-bottom: 10px; margin-top: 20px"
              v-model="vacationTableParams.userName"
              size="mini"
              :placeholder="
                $lange == 'en' ? 'Place enter Username' : '请输入用户名'
              "
            ></el-input>
          </div>
          <div class="bottom">
            <cc-table
              :config="VacationTableConfig"
              :params="vacationTableParams"
              :refesh-params="vacationTableRefesh"
            ></cc-table>
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import Gantt from "../../components/Gantt";
import moment from "moment";

export default {
  name: "StaffEngineer",
  components: {
    Gantt,
  },
  data() {
    return {
      categoryName: [
        {
          value: "机械工程师",
          label: this.$lange == "en" ? "Mechanic engineer" : "机械工程师",
        },
        {
          value: "电气工程师",
          label: this.$lange == "en" ? "Electrical engineer" : "电气工程师",
        },
        {
          value: "软件工程师",
          label: this.$lange == "en" ? "Software engineer" : "软件工程师",
        },
      ],
      skill: [
        {
          value: "安装",
          label: "安装",
        },
        {
          value: "售后",
          label: "售后",
        },
        {
          value: "质量",
          label: "质量",
        },
      ],
      exportDate: "",
      VacationTableConfig: {
        api: "admin/fsb/employee/queryVacation",
        showPager: true,
        pageSize: 10,
        columns: [
          {
            prop: "userName",
            lable: this.$lange == "en" ? "Engineer" : "工程师",
          },
          {
            lable: this.$lange == "en" ? "Vacation time" : "休假时间",
            render: (row) => {
              let startTime = moment(row.startTime).format("YYYY-MM-DD");
              let endTime = moment(row.endTime).format("YYYY-MM-DD");
              return `${startTime} ~ ${endTime}`;
            },
          },
        ],
        buttonsLabel: this.$lange == "en" ? "Operation" : "操作",
        buttons: [
          {
            name: this.$lange == "en" ? "Delete" : "删除",
            click: (row) => {
              this.$confirm("此操作会删除该休假记录, 是否确定?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
              }).then(() => {
                let data = {
                  id: row.id,
                };
                this.ccRequest
                  .do("admin/fsb/employee/delete", data, "GET")
                  .then((res) => {
                    this.$message({
                      type: "success",
                      message: "记录已删除",
                    });
                    this.vacationTableRefesh = new Date().getTime();
                    this.getData();
                  });
              });
            },
          },
        ],
      },
      vacationTableParams: {
        userName: "",
      },
      vacationTableRefesh: 0,

      engineerSelectorConfig: {
        api: "admin/fsb/employeeinfo/queryEngineerList?roleTips=engineer&pageSize=999&isAsc=true",
        valProp: "userid",
        labelProp: "username",
        width: "100%",
      },
      engineerParams: {
        startDate: "",
        endDate: "",
        userIds: "",
      },
      productSelectorConfig: {
        api: "admin/fsb/product/query?pageSize=999&isAsc=true",
        valProp: "jobId",
        labelProp: "jobId",
        width: "100%",
      },
      showReport: false,
      showVacation: false,
      //颜色数组
      colorArr: [
        "progress-green",
        "progress-blue",
        "progress-gold",
        "progress-skyblue",
        "progress-skyblue",
        "progress-skyblue",
        "progress-darkyellow",
        "progress-red",
        "progress-orange",
        "progress-pink",
        "progress-lightgreen",
      ],

      baseTableParams: {
        startDate: "",
        endDate: "",
        jobId: "",
      },
      baseTableConfig: {
        api: "admin/fsb/employeeinfo/queryDailyEmployee",
        showPager: true,
        columns: [
          {
            prop: "projectId",
            lable: this.$lange == "en" ? "Order NO." : "外派工单",
            minWidth: 160,
          },
          {
            prop: "jobId",
            lable: this.$lange == "en" ? "Job ID" : "Job ID",
            minWidth: 100,
          },
          {
            prop: "customerName",
            lable: this.$lange == "en" ? "Customer" : "客户",
            minWidth: 120,
          },
          {
            prop: "userName",
            lable: this.$lange == "en" ? "Engineer" : "工程师",
            minWidth: 120,
          },
          {
            prop: "userId",
            lable: this.$lange == "en" ? "Employee NO." : "工号",
            minWidth: 100,
          },
          {
            prop: "dailyTime",
            lable: this.$lange == "en" ? "Date" : "日期",
            minWidth: 100,
            render: (row) => {
              return moment(row.dailyTime).format("YYYY-MM-DD");
            },
          },
          {
            prop: "amStartTime",
            lable: this.$lange == "en" ? "Clock In" : "上班",
            minWidth: 120,
          },
          {
            prop: "pmStartTime",
            lable: this.$lange == "en" ? "Clock Out" : "下班",
            minWidth: 120,
          },
          {
            prop: "workHour",
            lable: this.$lange == "en" ? "Hours" : "工作时长",
            minWidth: 100,
          },
          {
            prop: "otherTime",
            lable: this.$lange == "en" ? "Rest Hours" : "休息时长",
            minWidth: 100,
          },
          {
            prop: "travelTime",
            lable: this.$lange == "en" ? "Travelling Hours" : "旅途时长",
            minWidth: 100,
          },
          {
            prop: "remark",
            lable: this.$lange == "en" ? "Note" : "备注",
            minWidth: 100,
          },
          {
            prop: "amCity",
            lable: this.$lange == "en" ? "Clock In Location" : "上班打卡地点",
            minWidth: 100,
          },
          {
            prop: "pmCity",
            lable: this.$lange == "en" ? "Clock Out Location" : "上班打卡地点",
            minWidth: 100,
          },
          // {
          //   prop: "projectName",
          //   lable: "任务",
          //   minWidth: 150,

          // },
          // {
          //   prop: "dailyTime",
          //   lable: "日期",
          //   type: "date",
          //   render: (row) => {
          //     return moment(row.dailyTime).format("YYYY-MM-DD");
          //   },
          //   minWidth: 120,
          // },
          // {
          //   prop: "amStartTime",
          //   lable: "上班时间",
          //   minWidth: 100,
          // },
          // {
          //   prop: "amAddress",
          //   lable: "上班打卡地址",
          //   minWidth: 150,
          // },
          // {
          //   prop: "pmStartTime",
          //   lable: "下班时间",
          // },
          // {
          //   prop: "pmAddress",
          //   lable: "下班打卡地址",
          //   minWidth: 150,
          // },
          // {
          //   prop: "workHour",
          //   lable: "工作小时",
          // },
          // {
          //   prop: "travelTime",
          //   lable: "旅途",
          // },
          // {
          //   prop: "otherTime",
          //   lable: "其他",
          // },
          // {
          //   prop: "remark",
          //   lable: "备注",
          //   minWidth: 150,
          // },
        ],
        buttons: [],
      },
      monthRadio: "120",
      tableConfig: {
        showPager: false,
        columns: [
          {
            prop: "userName",
            lable: this.$lange === "en" ? "Engineer" : "工程师",
            type: "click",
            clickFun: (row) => {
              console.log(row);
              this.$router.push({
                path: "/admin/staff/list/des",
                query: {
                  id: row.userId,
                },
              });
            },
          },
          {
            prop: "categoryName",
            lable: this.$lange === "en" ? "Category" : "工程师类别",
            type: "input",
          },
          {
            prop: "skill",
            lable: this.$lange === "en" ? "Skill" : "技能",
            type: "input",
          },
          {
            prop: "station",
            lable: this.$lange === "en" ? "Position" : "位置",
            type: "input",
          },
        ],
      },
      refeshTable: -1, //控制表格 reload
      ganttTableData: [],
      tableParams: {
        userName: "",
        categoryName: "",
        skill: "",
        station: "",
        startDate: "",
        days: "60",
      },
      showDateRange: {
        startTime: "",
        endTime: "",
      },
      monthData: new Date(),
      nowDate: moment(new Date()).format("YYYY-MM-DD"),
      loadTable: false,
      engineerData: [],
      ganttData: {},
    };
  },
  methods: {
    exportDateChange(e) {
      if (e) {
        this.baseTableParams.startDate = e[0];
        this.baseTableParams.endDate = e[1];
      } else {
        this.baseTableParams.startDate = "";
        this.baseTableParams.endDate = "";
      }
    },
    //导出日报
    exportDailyReport() {
      let pData = this.baseTableParams;
      console.log(this.$apis, "$apis");
      let url = `${this.$apis.config.server}admin/fsb/employeeinfo/exportDailyEmployee?startDate=${pData.startDate}&endDate=${pData.endDate}&jobId=${pData.jobId}`;
      window.open(url);
    },
    changeShowDateRange() {
      let num = this.monthRadio / 2;
      let timestamp = new Date().getTime();
      let startTime = timestamp - num * 86400000;
      let endTime = timestamp + num * 86400000;
      this.showDateRange.startTime = moment(startTime).format("YYYY-MM-DD");
      this.showDateRange.endTime = moment(endTime).format("YYYY-MM-DD");
      console.log(
        num,
        this.showDateRange.startTime,
        this.showDateRange.endTime,
        "numnumnumnumnum"
      );
    },
    vacationEngineer() {
      let data = this.engineerParams;
      this.ccRequest
        .do("admin/fsb/employeeinfo/insertVacation", data, "GET")
        .then((res) => {
          this.$message({
            type: "success",
            message: "录入成功",
          });
          this.showVacation = false;
          this.vacationTableRefesh = new Date().getTime();
          this.getData();
        })
        .catch((res) => {
          this.$message({
            type: "error",
            message: res.response.data.message,
          });
        });
    },
    daysChange() {
      this.getData();
      this.tableParams.days = this.monthRadio;
    },
    getData() {
      let startDate = moment(this.monthData);
      let data = {
        startDate: startDate.format("YYYY-MM"),
        days: startDate.daysInMonth(),
      };
      this.ccRequest
        .do("admin/fsb/employeeinfo/queryEngineerInfo", data, "GET")
        .then((res) => {
          res.dayTotal = 0;
          for (let i in res.expatriateList) {
            res.dayTotal += res.expatriateList[i].value;
          }
          console.log(res);
          this.engineerData = res;
          this.changeShowDateRange();
          this.initGanntDate();
        });
    },
    changeDate() {
      this.getData();
    },
    saveValue(e) {
      let text = "";
      if (e.expatriateOrder) {
        text = "订单号:" + e.expatriateOrder.id + "/";
      }
      if (e.projectTasks) {
        text += "JobID: " + e.projectTasks.jobId;
      }
      return text;
    },
    initGanntDate() {
      let data = this.tableParams;
      data.startDate = moment(new Date()).format("YYYY-MM-DD");
      data.days = this.monthRadio / 2;
      this.tableParams = data;
      this.ccRequest
        .do("admin/fsb/employeeinfo/queryEngineer", data, "GET")
        .then((res) => {
          this.ganttTableData = JSON.parse(JSON.stringify(res.rows));
          this.refeshTable = new Date().getTime();
          for (let i in res.rows) {
            let startTime = false;
            let endTime = false;
            for (let j in res.rows[i].items) {
              if (res.rows[i].items[j].type !== 2) {
                if (res.rows[i].items[j].type == 0) {
                  res.rows[i].items[j].workType = 6;
                }
                if (res.rows[i].items[j].type == 1) {
                  res.rows[i].items[j].workType = 4;
                }
                // res.rows[i].items[
                //   j
                // ].value = `${res.rows[i].items[j].customerName} - ${res.rows[i].items[j].value}`;
                res.rows[i].items[j].value = this.saveValue(
                  res.rows[i].items[j]
                );
              } else {
                res.rows[i].items[j].value = `休假`;
                res.rows[i].items[j].workType = 5;
              }

              //这里用时间判断，是为了避免时间短于甘特图渲染的时间，造成渲染错误
              let newStartTime = new Date(
                res.rows[i].items[j].startTime
              ).getTime();
              let newEndTime = new Date(res.rows[i].items[j].endTime).getTime();
              if (newStartTime < startTime || startTime === false) {
                startTime = newStartTime;
              }
              if (newEndTime > endTime || endTime === false) {
                endTime = newEndTime;
              }
            }
            res.rows[i].startTime = moment(new Date(startTime)).format(
              "YYYY-MM-DD"
            );
            res.rows[i].endTime = moment(new Date(endTime)).format(
              "YYYY-MM-DD"
            );
          }
          this.ganttData = res.rows;
          this.loadTable = true;
        });
    },
    checkLanguage() {
      if (this.$lange == "en") {
        this.tableConfig = {
          api: "admin/fsb/employeeinfo/queryEngineer",
          showPager: false,
          columns: [
            {
              prop: "userName",
              lable: "Engineer",
              type: "input",
            },
            {
              prop: "station",
              lable: "Position",
              type: "input",
            },
          ],
        };
        this.baseTableConfig = {
          api: "admin/fsb/employeeinfo/queryDailyEmployee",
          showPager: true,
          columns: [
            {
              prop: "jobId",
              lable: "Job ID",
            },
            {
              prop: "projectName",
              lable: "Task",
            },
            {
              prop: "userName",
              lable: "Engineer",
            },
            {
              prop: "roleName",
              lable: "Role",
            },
            {
              prop: "dailyTime",
              lable: "Date",
              type: "date",
              render: (row) => {
                return moment(row.dailyTime).format("YYYY-MM-DD");
              },
            },
            {
              prop: "amStartTime",
              lable: "Morning start time",
            },
            {
              prop: "amEndTime",
              lable: "Morning end time",
            },
            {
              prop: "pmStartTime",
              lable: "Afternoon start time",
            },
            {
              prop: "pmEndTime",
              lable: "Afternoon end time",
            },
            {
              prop: "workHour",
              lable: "Work Hour",
            },
            {
              prop: "travelTime",
              lable: "Travel Time",
            },
            {
              prop: "otherTime",
              lable: "Other Time",
            },
            {
              prop: "remark",
              lable: "Remark",
            },
          ],
          buttons: [],
        };
        this.VacationTableConfig = {
          api: "admin/fsb/employee/queryVacation",
          showPager: true,
          pageSize: 10,
          columns: [
            {
              prop: "userName",
              lable: "Engineer",
            },
            {
              lable: "Vacation Time",
              render: (row) => {
                let startTime = moment(row.startTime).format("YYYY-MM-DD");
                let endTime = moment(row.endTime).format("YYYY-MM-DD");
                return `${startTime} ~ ${endTime}`;
              },
            },
          ],
          buttons: [
            {
              name: "Delete",
              click: (row) => {
                this.$confirm("Now is Delete Vacation Record", "提示", {
                  confirmButtonText: "Yes",
                  cancelButtonText: "No",
                  type: "warning",
                }).then(() => {
                  let data = {
                    id: row.id,
                  };
                  this.ccRequest
                    .do("admin/fsb/employee/delete", data, "GET")
                    .then((res) => {
                      this.$message({
                        type: "success",
                        message: "Record is deleted",
                      });
                      this.vacationTableRefesh = new Date().getTime();
                      this.getData();
                    });
                });
              },
            },
          ],
        };
      }
    },
  },
  mounted() {
    this.checkLanguage();
    this.getData();
    this.initGanntDate();
  },
};
</script>
<style lang="scss">
.enter-vacation {
  .item-title {
    display: inline-block;
    margin-right: 10px;
    width: 100px;
    text-align: right;
  }
}
.progress-box {
  .el-progress {
    flex: 1;
  }
}

.progress-green {
  .el-progress-bar__inner {
    background: #70b603;
  }
}

.progress-blue {
  .el-progress-bar__inner {
    background: #49a9ee;
  }
}

.progress-gold {
  .el-progress-bar__inner {
    background: #ffd86e;
  }
}

.progress-skyblue {
  .el-progress-bar__inner {
    background: #81d3f8;
  }
}

.progress-skyblue {
  .el-progress-bar__inner {
    background: #81d3f8;
  }
}

.progress-skyblue {
  .el-progress-bar__inner {
    background: #caf982;
  }
}

.progress-darkyellow {
  .el-progress-bar__inner {
    background: #e6c163;
  }
}

.progress-red {
  .el-progress-bar__inner {
    background: #a30014;
  }
}

.progress-orange {
  .el-progress-bar__inner {
    background: #f59a23;
  }
}

.progress-pink {
  .el-progress-bar__inner {
    background: #ec808d;
  }
}

.progress-lightgreen {
  .el-progress-bar__inner {
    background: #aaded4;
  }
}
</style>
<style scoped lang="scss">
.staff-engineer {
  .progress-box {
    background: #ffffff;
    padding: 20px;

    .title {
      font-size: 22px;
    }

    .lists {
      margin-top: 20px;

      .list {
        margin-top: 10px;
        /*padding-right: 50px;*/

        p {
          // text-align: right;
          min-width: 110px;
          padding-right: 20px;
        }
      }
    }
  }

  .table-box {
    margin-top: 20px;
    padding: 20px;
    background: #ffffff;

    .top {
      font-size: 14px;
      flex-wrap: wrap;

      > *:last-child {
        // margin-left: 500px;
      }

      .btn-group {
      }
      .left {
        display: flex;
        align-items: center;
        justify-content: space-between;
        width: 700px;
        margin-bottom: 10px;
      }
    }

    .gantt-box {
      margin-top: 20px;
      .input-group {
        display: flex;
        justify-content: space-between;
        .group-left {
          display: flex;
          .input_item {
            width: 180px;
            margin-right: 20px;
          }
        }
        .group-right {
          display: flex;
          .color_box {
            // width: 56px;
            padding: 0 10px;
            height: 28px;
            border-radius: 4px;
            display: flex;
            align-items: center;
            justify-content: center;
            color: #f1f1f1;
            margin-left: 20px;
            &.color_1 {
              //修改圖表顏色
              // background: #1aa689;
              background: #ffff00 !important;
              color: #858585;
            }
            &.color_2 {
              // background: #aaded4;
              background: #00b050 !important;
            }
            &.color_3 {
              // background: #02a7f0;
              background: #99ccff;
            }
          }
        }
      }
    }
  }
}
</style>
<style lang="scss">
/*修改圖表顏色 */
.staff_engineer_box {
  .at-eg-working .at-eg-task-inner {
    background: #00b050 !important;
  }
  .at-eg-default .at-eg-task-inner {
    background: #99ccff !important;
  }
  .at-eg-primary .at-eg-task-inner {
    background: #ffff00 !important;
    color: #858585 !important;
  }
}
</style>